<template>
  <div>
    <Banner />
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="page-content-state col-12">
            <span class="page-content-state__icon fal fa-exclamation-circle"></span>
            <div class="page-content-state__header">{{ __('label:error 404') }}</div>
            <div class="page-content-state__content" v-html="__('info:error 404')"></div>
            <div class="page-content-state__content">
              <router-link :to="{ name: 'home-page' }">Back to {{ __('label:app title') }} Home</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Banner from './common/Banner.vue'

export default {
  mounted: function () {
    this.$store.dispatch('global/updateBreadcrumbs')
  },
  computed: {
    ...mapState({
      pageError: (state) => state.global.pageData && state.global.pageData.page == 'error',
      pageData: (state) => state.global.pageData
    })
  },
  components: { Banner }
}
</script>
